module.exports = __webpack_public_path__ + "e8f098029596be7677189471220a04b7.pdf";